import React from "react";

function Sandbox() {
  return <div>Sandbox</div>;
}

export default Sandbox;
